import { debugLog } from "./debugLog";
import { convertLegacyFeimEvent } from "./feimBackwardCompatibility";
import { getGameOrigin, isAllowedGameOrigin, isAllowedOrigin } from "./postMessageOrigin";
import { publishToModules } from "./messageBus";
export const createMessageEventListener = () => {
    window.addEventListener("message", (event) => {
        var _a;
        let gameEvent = event.data.feimGameEvent;
        if (gameEvent === undefined) {
            if (isAllowedOrigin(event.origin)) {
                void publishToModules("nx-message", event);
            }
            return;
        }
        else {
            gameEvent = convertLegacyFeimEvent(gameEvent);
            if (process.env.MODE === "development") {
                if (gameEvent === "game-hello") {
                    console.log(JSON.stringify((_a = event.data.payload) !== null && _a !== void 0 ? _a : "FEIM version not detected"));
                }
            }
        }
        if (isAllowedGameOrigin(event.origin)) {
            void publishToModules(gameEvent, event.data.payload);
        }
        else {
            debugLog(`Invalid game event origin ${event.origin} - Expected ${getGameOrigin()}`, event.data);
        }
    });
};
